export const ESTABLISHMENT_CLICKOUT_SECTIONS = {
  ESTABLISHMENT_BEST_PRICE: 'ESTABLISHMENT_BEST_PRICE',
  ESTABLISHMENT_CANCELLATION: 'ESTABLISHMENT_CANCELLATION',
  ESTABLISHMENT_CTA: 'ESTABLISHMENT_CTA',
  ESTABLISHMENT_CTA_STICKY: 'ESTABLISHMENT_CTA_STICKY',
  ESTABLISHMENT_IMAGE: 'ESTABLISHMENT_IMAGE',
  ESTABLISHMENT_LINK_STICKY: 'ESTABLISHMENT_LINK_STICKY',
  ESTABLISHMENT_MATCHING: 'ESTABLISHMENT_MATCHING',
  ESTABLISHMENT_MATCHING_GRID_COMMENTS: 'ESTABLISHMENT_MATCHING_GRID_COMMENTS',
  ESTABLISHMENT_MATCHING_GRID_CTA: 'ESTABLISHMENT_MATCHING_GRID_CTA',
  ESTABLISHMENT_MATCHING_GRID_EXTRAS: 'ESTABLISHMENT_MATCHING_GRID_EXTRAS',
  ESTABLISHMENT_MATCHING_GRID_LOGO: 'ESTABLISHMENT_MATCHING_GRID_LOGO',
  ESTABLISHMENT_MATCHING_GRID_PRICE: 'ESTABLISHMENT_MATCHING_GRID_PRICE',
  ESTABLISHMENT_MATCHING_GRID_RATING: 'ESTABLISHMENT_MATCHING_GRID_RATING',
  ESTABLISHMENT_PARTNER_LOGO: 'ESTABLISHMENT_PARTNER_LOGO',
  ESTABLISHMENT_PRICE_OTHER: 'ESTABLISHMENT_PRICE_OTHER',
  ESTABLISHMENT_PRICE_WINNER: 'ESTABLISHMENT_PRICE_WINNER',
  ESTABLISHMENT_READ_MORE: 'ESTABLISHMENT_READ_MORE',
};
